"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const utils_1 = require("../helpers/utils");
const T4_SB = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T4_SB',
    defaultFontWeight: 'T4_SB',
    defaultLineHeight: 'T4_SB'
})}
  `;
exports.default = T4_SB;
//# sourceMappingURL=title-four-semi-bold.js.map